import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import GradientHeading from 'components/GradientHeading';
import useBoolean from 'hooks/useBoolean';
import RoomTypeList from 'page-sections/room-type/RoomTypeList';
import { useEffect, useState } from 'react';
import axiosInstance from 'utils/axios';

const EventHotel = () => {
    const theme = useTheme();

    const [roomTypes, setRoomTypes] = useState([]);

    const loadingRoom = useBoolean(true);

    useEffect(() => {
        const fetchRoomTypes = async () => {
            try {
                const res = await axiosInstance.get('/api/pub/room-types');
                setRoomTypes(res.data);
            } catch (err) {
                console.error('Failed to fetch room types:', err);
            } finally {
                loadingRoom.onFalse();
            }
        };
        fetchRoomTypes();
    }, []);

    return (
        <Box bgcolor={theme.palette.alternate.main}>
            <Container>
                <Box
                    sx={{
                        py: { xs: 6, md: 8 },
                        background: `linear-gradient(135deg, ${theme.palette.grey[50]} 0%, ${theme.palette.grey[100]} 100%)`,
                    }}
                >
                    <Container maxWidth="lg">
                        <Box sx={{ textAlign: 'center', mb: { xs: 5, md: 7 } }}>
                            <GradientHeading label="Hotel Room" />
                            <Typography
                                variant="body1"
                                sx={{ color: 'text.secondary', mt: 1 }}
                            >
                                All prices are in Indonesian Rupiah (IDR)
                            </Typography>
                        </Box>

                        <RoomTypeList
                            roomTypes={roomTypes}
                            loadingRooms={loadingRoom.value}
                        />
                    </Container>
                </Box>
            </Container>
        </Box>
    );
};

export default EventHotel;
